import React from "react";

export class VacantFloorJou extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hide: true };
    const floors = this.props.floors;
    Object.keys(floors).map(floor => {
      floors[floor] = Object.values(floors[floor]).sort();
    });
  }
  toggleHide = hideVisible => {
    this.setState({ hide: !hideVisible });
  };
  render() {
    const floors = this.props.floors;
    return (
      <div>
        {Object.keys(floors).length > 0 && <div className="vacant">
          <div className="btn_plus" onClick={() => this.toggleHide(this.state.hide)}>
            <span>空き状況</span>
            <i className={"fas " + (!this.state.hide ? 'fa-angle-double-up' : 'fa-angle-double-down')}></i>
          </div>
        </div>}
        {!this.state.hide && <table className="floors">
          {Object.keys(floors).map(floor =>  (<tr>
              <td>{floor}</td>
              <td>{Object.values(floors[floor]).map(jou =>  (<span>{jou}帖　</span>))}</td>
           </tr>))}
        </table>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/VacantFloorJou.jsx